export const supportGoogleCapchaHost = [
  'bybitgum.org',
  'bybitgum.com',
  'bybit-global.com',
  'bybit.biz',
  'bybit.cloud',
  'bybitx.global',
  'bybit.com',
  'bycloud.org',
  'bybitglobal.com',
  'bytick.com',
  'bybit.global',
  'bybits.io',
  'bybits.org',
  'bybit-global.com',
  'bybitgum.org',
  'explorebybit.com',
  'bybit.ae',
  'seabit.net',
  'byffbb.com',
  'ng-dex.com',
  'bit-love.com',
  'bitlove-dex.com',
  'byabcd.com',
  'byapp.io',
  'bygame.io',
  'byeco.io',
  'bbgum.biz',
  'bybit.org',
  'bybit.nl',
  'byhkbit.com',
  'bybitcard.com',
  'bybitcards.com',
  'bybit-tr.com',
  'bybit.kz',
  'bybit.eu',
  'bybit-ge.com',
  'kbybit.com',
  'bybit.id',
  'lovebybit.com',
];
